import React, { useState } from "react"
import emailjs from "emailjs-com"
import { Link, graphql, useStaticQuery } from "gatsby"
import { Modal } from "react-bootstrap"
import "./Footer.css"
import Linkedin from "../../assets/images/linkedin.png"
import Twitter from "../../assets/images/twitter.png"
import Youtube from "../../assets/images/youtube.png"

const Footer = () => {
  const [email, setEmail] = useState("")
  const [confirmationVisible, confirmationSetVisible] = useState(false)
  const handleSubmit = e => {
    e.preventDefault()
    emailjs
      .sendForm(
        "service_qkbep48",
        "template_95d163x",
        e.target,
        "user_H1giHzeT00K7WW4tInQOn"
      )
      .then(
        result => {
          console.log(result)
        },
        error => {
          console.log(error.text)
        }
      )
    emailjs
      .sendForm(
        "service_qkbep48",
        "template_8hke6d4",
        e.target,
        "user_H1giHzeT00K7WW4tInQOn"
      )
      .then(
        result => {
          console.log(result)
        },
        error => {
          console.log(error.text)
        }
      )
    setEmail("")
    handleShowConfirmation()
  }
  const handleShowConfirmation = () => confirmationSetVisible(true)
  const handleCloseConfirmation = () => confirmationSetVisible(false)

  const data = useStaticQuery(graphql`
    query {
      allContentfulFooter {
        nodes {
          email
          logo {
            file {
              url
            }
          }
          subTitle
          updates
          txtTwo
          txtThree
          txtOne
          txtFour
          socialLinkOne
          socialLinkTwo
          socialLinkThree
          privacyLink
          termsLink
          confirmationMessage
        }
      }
      allContentfulHeader {
        nodes {
          btnFour
          btnFive
          btnOne
          btnThree
          btnTwo
        }
      }
    }
  `)
  const { allContentfulFooter, allContentfulHeader } = data
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-top">
          <div className="row justify-content-between ">
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 col-tagline">
              <div className="header-icon margin-bot">
                <Link to="/">
                  <img
                    src={allContentfulFooter.nodes[0].logo.file.url}
                    alt="Workeye Logo"
                  />
                </Link>
              </div>
              <h2>{allContentfulFooter.nodes[0].subTitle}</h2>
              <h5>{allContentfulFooter.nodes[0].email}</h5>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 footer-menu">
              <h2>Menu</h2>
              <ul className="foot-menu">
                <li>
                  <Link to="/test-drive">
                    <button className="foot-btn">
                      {allContentfulHeader.nodes[0].btnOne}
                    </button>
                  </Link>
                </li>
                <li>
                  <Link to="/solution">
                    <button className="foot-btn">
                      {allContentfulHeader.nodes[0].btnTwo}
                    </button>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/partners">
                    <button className="foot-btn">
                      {allContentfulHeader.nodes[0].btnThree}
                    </button>
                  </Link>
                </li>
                <li>
                  <Link to="/custom-quote">
                    <button className="foot-btn">Custom Quote</button>
                  </Link>
                </li> */}
                <li>
                  <Link to="/blog">
                    <button className="foot-btn">
                      {allContentfulHeader.nodes[0].btnFour}
                    </button>
                  </Link>
                </li>
                <li>
                  <Link to="/contact">
                    <button className="foot-btn">
                      {allContentfulHeader.nodes[0].btnFive}
                    </button>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 footer-form">
              <h2>{allContentfulFooter.nodes[0].updates}</h2>
              <div className="footer-subscribe-form">
                <div>
                  <form onSubmit={handleSubmit}>
                    <input
                      placeholder="your email"
                      value={email}
                      type="email"
                      name="user_email"
                      onChange={e => setEmail(e.currentTarget.value)}
                    />
                    <button type="submit">submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom  container ">
          <div className="social-media d-flex align-items-center justify-content-between">
            <div className="social-media d-flex align-items-center justify-content-between">
              <li>
                <a
                  href={allContentfulFooter.nodes[0].socialLinkOne}
                  target="blank"
                >
                  <img src={Linkedin} alt="LinkedIn" />
                </a>
              </li>
              <li className="li-margin">
                <a
                  href={allContentfulFooter.nodes[0].socialLinkTwo}
                  target="blank"
                >
                  <img src={Twitter} alt="Twitter" />
                </a>
              </li>
              <li className="li-margin-1">
                <a
                  href={allContentfulFooter.nodes[0].socialLinkThree}
                  target="blank"
                >
                  <img src={Youtube} alt="YouTube" />
                </a>
              </li>
            </div>
            <div className="social-media d-flex align-items-center justify-content-between pay">
              <li>
                <a href={allContentfulFooter.nodes[0].privacyLink}>
                  <p>{allContentfulFooter.nodes[0].txtOne}</p>
                </a>
              </li>
              <li>
                <a href={allContentfulFooter.nodes[0].termsLink}>
                  <p>{allContentfulFooter.nodes[0].txtTwo}</p>
                </a>
              </li>
              <li>
                <Link to="/pay">
                  <p>{allContentfulFooter.nodes[0].txtThree}</p>
                </Link>
              </li>
            </div>
            <li>
              <p>{allContentfulFooter.nodes[0].txtFour}</p>
            </li>
          </div>
        </div>
      </div>

      <Modal
        style={{ marginTop: "15%", height: "100%" }}
        show={confirmationVisible}
        onHide={() => confirmationSetVisible(false)}
      >
        <Modal.Body
          style={{
            fontSize: "25px",
            backgroundColor: "#3e812c",
            color: "white",
          }}
        >
          {allContentfulFooter.nodes[0].confirmationMessage}
          <button
            onClick={handleCloseConfirmation}
            class="close"
            aria-label="Close"
            type="submit"
            style={{ opacity: "1" }}
          >
            <span
              style={{ fontSize: "40px", color: "white", opacity: "1" }}
              aria-hidden="true"
            >
              &times;
            </span>
          </button>
        </Modal.Body>
      </Modal>
    </footer>
  )
}

export default Footer
